"use client";

import * as React from "react";

const PortalScopeCtx = React.createContext<HTMLElement | null>(null);

/** Returns the current portal container element from {@link PortalScopeCtx}, or `null` if none is provided. */
export const usePortalScope = (): HTMLElement | null =>
	React.useContext(PortalScopeCtx);

type PortalScopeProviderProps = {
	container: HTMLElement | null;
	children: React.ReactNode;
};

/** Provide a DOM node for descendants to portal into. */
export function PortalScopeProvider({
	container,
	children,
}: PortalScopeProviderProps) {
	return (
		<PortalScopeCtx.Provider value={container}>
			{children}
		</PortalScopeCtx.Provider>
	);
}
